// extracted by mini-css-extract-plugin
export default {"layout":"LoginPage_layout__8r2yI","form-section":"LoginPage_form-section__Tm2Yt","banner-section":"LoginPage_banner-section__9AGO6"};